import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { PgFormField, PgFormLayout } from '../../models/form.model';
import { ConfigFormLayoutGroupField } from '../../models/config.resources.model';
import { PGUtilities } from '../../utilities/pg-utilities';
import { LocalizationService } from '../../services/localization.service';
import { EnvironmentService } from '../../services/environment.service';

@Component({
    selector: 'app-pg-detail',
    templateUrl: './pg-detail.component.html',
    styleUrls: ['./pg-detail.component.scss'],
    standalone: false
})
export class PgDetailComponent implements OnInit, OnChanges {
    @Input() formLayout:PgFormLayout = null;

    @Input() formValues:any = null;

    @Input() hideEmpty:boolean;
    @Input() currentLanguage:boolean;

    cleanFormValues:any = null;

    constructor(private localizationService:LocalizationService, private environmentService:EnvironmentService) { }

    ngOnInit() {
    }

    ngOnChanges() {
        this.cleanFormValues = {};

        if(this.formValues != null) {
            this.cleanFormValues = JSON.parse(JSON.stringify(this.formValues))
        }
        else {
            for(let _field of this.formLayout.fieldList) {
                this.cleanFormValues[_field.name] = _field.value
            }
        }

        let _languages:Array<string> = PGUtilities.tryParseJSON(this.cleanFormValues.languages)

        if(_languages != null) {
            for(let _field of this.formLayout.fieldList) {
                if(_field.locale && !this.localizationService.format.hasTypeInternalLanguageHandling(_field.type)) {
                    let _parsed = PGUtilities.tryParseJSON(this.cleanFormValues[_field.name])

                    if(_parsed != null) {
                        let _clean = {}

                        for(let i in _parsed) {
                            if(_languages.indexOf(i) != -1) {
                                _clean[i] = _parsed[i]
                            }
                        }

                        this.cleanFormValues[_field.name] = JSON.stringify(_clean);
                    }
                }
            }
        }
    }

    getValueForField(field:PgFormField) {
        return this.cleanFormValues[field.name]
    }

    isFieldVisible(field:ConfigFormLayoutGroupField) {
        let _cField = this.formLayout.getFieldByName(field.name)
        let _cValue = this.getValueForField(_cField);

        if(this.hideEmpty && (_cValue == null || _cValue == '' || _cValue == '[]')) {
            return false
        }
        else {
            return this.formLayout.isFieldVisible(field, this.cleanFormValues)
        }
    }

    getCurrency() {
        return this.cleanFormValues.currency || this.environmentService.getDefaultCurrency()
    }

    private _lastLanguageValString = null;
    private _lastLanguageValObj = null;

    getLanguages() {
        let _stringVal = null;

        if(this.cleanFormValues.languages != null) {
            _stringVal = JSON.stringify(this.cleanFormValues.languages);
        }

        if(_stringVal != this._lastLanguageValString) {
            this._lastLanguageValObj = JSON.parse(_stringVal)
        }

        return this._lastLanguageValObj;
    }
}
